import React, { useEffect, useState } from "react";
import { apiRequest } from "../services/api";
import { Link } from 'react-router-dom';

const HeroCarousel = () => {
    const [slides, setSlides] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiRequest({ url: "/hero-section" })
            .then((res) => {
                if (res.success && Array.isArray(res.data)) {
                    setSlides(res.data);
                } else {
                    console.warn("Unexpected response format:", res);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error loading hero slides:", err.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <div>Loading slider...</div>;
    return (
        <div className="carousel-header">
            <div id="carouselId" className="carousel slide" data-bs-ride="carousel">
                <ol className="carousel-indicators">
                    {slides.map((_, index) => (
                        <li
                            key={index}
                            data-bs-target="#carouselId"
                            data-bs-slide-to={index}
                            className={index === 0 ? "active" : ""}
                        ></li>
                    ))}
                </ol>

                <div className="carousel-inner" role="listbox">
                    {slides.map((slide, index) => (
                        <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                            <img src={slide.image} className="img-fluid" alt={`Slide ${index + 1}`} />
                            <div className="carousel-caption">
                                <div className="p-3" style={{ maxWidth: "900px" }}>
                                    <h5
                                        className="text-white text-uppercase fw-bold mb-4"
                                        style={{ letterSpacing: "3px" }}
                                    >
                                        {slide.subtitle}
                                    </h5>
                                    <h1 className="display-4 text-capitalize text-white mb-4">
                                        {slide.title}
                                    </h1>
                                    {slide.description && (
                                        <p className="mb-5 fs-6">{slide.description}</p>
                                    )}
                                    <div className="d-flex align-items-center justify-content-center">
                                        {/* <a
                                            className="btn-hover-bg btn btn-primary rounded-pill text-white py-3 px-5"
                                            href="#"
                                        >
                                            Discover Now
                                        </a> */}
                                        <Link
                                            to="/packages"
                                            className="btn-hover-bg btn btn-primary rounded-pill text-white py-3 px-5"
                                        >
                                            Discover Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselId"
                    data-bs-slide="prev"
                >
                    <span className="carousel-control-prev-icon btn bg-primary" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselId"
                    data-bs-slide="next"
                >
                    <span className="carousel-control-next-icon btn bg-primary" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    );
};

export default HeroCarousel;
